import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useConfig } from "../../../contexts/config-context.js";
import { useForcedState, ForcedState } from "../../../contexts/forced-state-context.js";
import { getColor } from "../utils/drawer.js";
import { SignatureDrawer } from "./signature-drawer.js";
import styles from "./signature-drawer-wut.module.scss";
const SignatureDrawerWUT = ({
  hasError,
  required,
  ...props
}) => {
  const { compId } = useConfig();
  const inputColor = getColor(compId, "--wix-forms-formInputValueColor");
  const penColor = inputColor && `rgb(${inputColor})`;
  const forcedState = useForcedState();
  const forcedError = forcedState.includes(ForcedState.INPUT_FIELDS_ERROR);
  const forcedHover = forcedState.includes(ForcedState.INPUT_FIELDS_HOVER);
  return /* @__PURE__ */ jsx(
    SignatureDrawer,
    {
      ...props,
      className: classNames(styles.container, {
        [styles.error]: hasError || forcedError,
        [styles.hover]: forcedHover
      }),
      penColor
    }
  );
};
export {
  SignatureDrawerWUT
};
//# sourceMappingURL=signature-drawer-wut.js.map
